export class QueryHelper {
  static getAccessToken(): string | null {
    return window.localStorage.getItem('accessToken');
  }
}
